import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createForm: {
    fullname: "",
    email: "",
    username: "",
    password: "",
    passwordConfirm: "",
    branch: null,
  },
  updateForm: {
    id: "",
    fullname: "",
    email: "",
    branch: null,
  },
  resetPasswordForm: { id: null, newPassword: "" },
  isEdit: false,
  isOpenModal: false,
  isOpenUpdateModal: false,
  isOpenPasswordModal: false,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    onChangeAdminForm: (state, { payload }) => {
      state.createForm = {
        ...state.createForm,
        fullname: payload.fullname,
        email: payload.email,
        username: payload.username,
        password: payload.password,
        passwordConfirm: payload.passwordConfirm,
        branch: payload.branch,
      };
    },
    onChangeAdminUpdateForm: (state, { payload }) => {
      state.updateForm = {
        ...state.updateForm,
        fullname: payload.fullname,
        email: payload.email,
        branch: payload.branch,
      };
    },
    setIsEditAdmin: (state, { payload }) => {
      state.isEdit = payload;
    },
    clearAdminForm: (state) => {
      state.createForm = initialState.createForm;
      state.updateForm = initialState.updateForm;
    },
    toggleAdminModal: (state) => {
      state.isOpenModal = !state.isOpenModal;
    },
    toggleAdminUpdateModal: (state) => {
      state.isOpenUpdateModal = !state.isOpenUpdateModal;
    },
    toggleAdminPasswordModal: (state) => {
      state.isOpenPasswordModal = !state.isOpenPasswordModal;
    },
    clearSelectBranch: (state) => {
      state.createForm.branch = null;
      state.updateForm.branch = null;
    },
    setResetAdminPassword: (state, { payload }) => {
      state.resetPasswordForm = {
        id: payload.id,
        newPassword: payload.password,
      };
    },
    onChangeAdminPasswordForm: (state, { payload }) => {
      state.resetPasswordForm = {
        ...state.resetPasswordForm,
        newPassword: payload.newPassword,
      };
    },
    setAdminForm: (state, { payload }) => {
      state.updateForm = {
        fullname: payload.fullname,
        email: payload.email,
        id: payload.id,
        branch: payload.branch,
      };
    },
  },
});

export const {
  onChangeAdminForm,
  setIsEditAdmin,
  clearAdminForm,
  toggleAdminModal,
  clearSelectBranch,
  toggleAdminPasswordModal,
  setResetAdminPassword,
  onChangeAdminPasswordForm,
  onChangeAdminUpdateForm,
  toggleAdminUpdateModal,
  setAdminForm,
} = adminSlice.actions;

export default adminSlice.reducer;
